import React from 'react';
import { NavLink } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import styles from './Navbar.module.css';

const Navbar = () => {
  const { productCatalog } = useFlags();

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        {productCatalog && (
          <NavLink
            to="/admin/product-catalog"
            className={styles.tab}
            activeClassName={styles.active}
            exact
          >
            PRODUCT CATALOG
          </NavLink>
        )}
        <NavLink
          to="/admin/campaigns"
          className={styles.tab}
          activeClassName={styles.active}
          exact
        >
          CAMPAIGNS
        </NavLink>
        <NavLink
          to="/admin/categories"
          className={styles.tab}
          activeClassName={styles.active}
          exact
        >
          CATEGORIES
        </NavLink>
        <NavLink
          to="/admin/carts"
          className={styles.tab}
          activeClassName={styles.active}
          exact
        >
          CARTS
        </NavLink>
        <NavLink
          to="/admin/discounts"
          className={styles.tab}
          activeClassName={styles.active}
          exact
        >
          DISCOUNTS
        </NavLink>
        <NavLink
          to="/admin/refills"
          className={styles.tab}
          activeClassName={styles.active}
          exact
        >
          REFILLS
        </NavLink>
      </div>
    </div>
  );
};

export default Navbar;
